import { gql } from '@apollo/client';

export const DELETE_NEWS_MUTATION = gql`
  mutation deleteNews($id: Int!) {
    deleteNews(id: $id) {
      id
    }
  }
`;
